function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_restart_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M190.6 20.4V50c12.7 4.3 23.8 10.4 32.9 18.3 21 18.1 31.4 45.2 31.4 80.6s-10.6 62.5-31.6 80.6c-19.5 16.8-47.8 25.6-81.7 25.6-33.9 0-62.2-8.8-81.7-25.6-21.1-18.1-31.7-45.2-31.7-80.6s10.7-62.5 31.7-80.6c1.3-1.2 2.8-2.3 4.2-3.4v41.4h28.4l.1-91.9H0v28.3l46.5.1C18 64.7.1 99.6.1 148.9c0 92.7 63.5 134.6 141.7 134.6s141.7-41.9 141.7-134.6c0-72.4-38.7-113.8-92.9-128.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.6 0h28.3v106.3h-28.3z"
})));